<div class="app-admin-wrap layout-sidebar-large">
	<router-outlet></router-outlet>
	<div class="module-loader" *ngIf="moduleLoading">
		<img src="assets/images/loading.gif" class="loading" alt="" />
	</div>
</div>